// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ProjectModelResetState {
  id?: string;
  show: boolean;
}

const initialState: ProjectModelResetState = {
  id: undefined,
  show: false,
};

export const projectModelResetSlice = createSlice({
  name: 'project-model-reset',
  initialState,
  reducers: {
    toggleResetModelDialog: state => {
      state.show = !state.show;
      if (!state.show) {
        state.id = undefined;
      }
    },
    setResetModelId: (state, action: PayloadAction<string | undefined>) => {
      state.id = action.payload;
      state.show = true;
    },
  },
});

export const { toggleResetModelDialog, setResetModelId } = projectModelResetSlice.actions;
export default projectModelResetSlice.reducer;
